<template>
	<div class="gw2">
		<div class="mb30 rc-block" >
				<p class="tit">充值ID</p>
				<input type="text" name="idtext" value="" v-model="uid" placeholder="请输入您需要充值的ID号">
				<a href="javascript:void(0);" class="check-name" @click="checkUserNum">验证昵称</a>
				<span class="uname">{{ nickname }}</span>
		</div>
		<div class="mb30 rc-block">
			<p class="tit" style="margin-bottom: 0;">充值档位</p>
			<div class="range">
					<div class="borderView" :class="{on:curIndex==index}" v-for="(item ,index ) in rangeData" @click="checkThis(index)">
						<span class="range-span fl">{{ item.amount }}<span v-if="item.free_amount!=0">+{{ item.free_amount }}</span></span>
						<div v-if="item.prop_list" class="packBottom">
							<div v-for="item1 in item.prop_list" class="forView">
								<img class="toushiI" :src="item1.img" />
								<span class="toushiT">{{ item1.name }}x{{ item1.validTime }}天</span>
							</div>
						</div>
					</div>
					<!-- <div v-if="item.prop_list" class="packBottom">
						<div v-for="item1 in item.prop_list">
							<img class="toushiI" :src="item1.img" />
							<span class="toushiT">{{ item1.name }}x{{ item1.validTime }}天</span>
						</div>
					</div> -->
			</div>
		</div>
		<div class="mb30 rc-block">
				<p class="tit">应付金额</p>
				<div class="amount">
					<p>购买：
						<span class="amount-span" v-if="curIndex!=-1">
							{{ rangeData[curIndex].amount }}
							<span v-if="rangeData[curIndex].free_amount!=0">+{{ rangeData[curIndex].free_amount }}</span>
						</span>
					<p class="price" v-if="curIndex!=-1">{{ rangeData[curIndex].fee }}元</p>
					<p class="price" v-else>0元</p>
				</div>
		</div>
		<div class="mb30 rc-block">
				<p class="tit">支付方式</p>
				<div class="payType">
					<!--<button type="button" name="button" @click="isShowPayBox=true">
						<span>扫码支付</span>
					</button>-->
					<button type="button" name="button" @click="payCharge">
						<span>支付宝</span>
					</button>
				</div>
				<!--<div class="pay-box" :class="{show:isShowPayBox}">
					<div class="ewm-block">
						<img src="../assets/erweima.png" alt="">
						<p>使用微信、支付宝扫一扫支付</p>
					</div>
					<p class="radio-p" :class="{checked:isChooseAgreement}" @click='isChooseAgreement=!isChooseAgreement'>我已认真阅读并同意<span @click.stop="toAgreement">《处CP充值协议》</span></p>
				</div>-->
		</div>
		<div class="mb30 rc-block">
				<p class="tit">充值说明</p>
				<div class="instructions">
						<p>1、爱豆可以用于恋爱物语语音APP内礼物的购买;</p>
						<p>2、充值订单问题请联系<span>QQ客服：800800664</span>咨询反馈</p>
				</div>
		</div>
		<div class="payform" v-html='payform'></div>
		<div class="tips" :class="{on: tips!=''}">
			<p>{{ tips }}</p>
		</div>
	</div>
</template>
<script>
import store from '@/store/store'
import { Params } from '@/util/util.js'
import Qs from 'qs'
	export default {
		name: 'recharge',
		data (){
			return {
				rangeData:[],//10010147
				curIndex:-1,
				isChooseAgreement:false,
				isShowPayBox:false,
				uid:'',
				nickname:"",
				payform:'',
				tips:''
			}
		},
		created(){
			this.$store.commit('inWhichPage',{page:'isRecharge'})
		},
		watch:{
			uid(val,oldval){
				if(val!=oldval && oldval!=""){
					this.nickname = "";
				}
			}
		},
		methods:{
			checkThis(){
				this.curIndex = arguments[0]
			},
			toAgreement(){
				console.log("Yes");
			},
			checkUserNum(){
				const that = this;
				if(that.uid.trim()==""){
					that.showTips("请输入用户账号",that);
				}else{
					var params = new Params(that,{
						uid:that.uid,
						method:'virgift.office.userinfo'
					});
					this.$axios.post(that.$store.state.urlData.url,Qs.stringify(params),{
						headers: {
	              'Content-Type':'application/x-www-form-urlencoded'
	          }
					}).then(function (res) {
						if (res.data.errCode==0) {
							that.nickname = res.data.data.nickname ;
						}else{
							that.showTips(res.data.errMsg,that);
							that.uid = '';
							that.nickname = '';
						}
					})
				}
			},
			payCharge(){
				const that = this;
				if (this.nickname.trim()=='') {
					that.showTips("请输入用户账号",that);
					return;
				}else if (this.uid.trim()=='') {
					that.showTips("请校验用户账号",that);
					return;
				}else if (this.curIndex==-1) {
					that.showTips("请选择充值档位",that);
					return;
				}else {
					var params = new Params(that,{
						pay_type	:'office_pc',
						method:'virgift.office.buy.bean',
						uid:that.uid,
						bs_id:that.rangeData[that.curIndex].bs_id
					});
					this.$axios.post(that.$store.state.urlData.url,Qs.stringify(params),{
						headers: {
								'Content-Type':'application/x-www-form-urlencoded'
						}
					}).then(function (res) {
						if (res.data.errCode==0) {
							var str = res.data.data.form;
							that.payform = str;
							that.$nextTick(_=>{ document.forms[0].submit() })
						}else{
							that.showTips(res.data.errMsg,that);
						}
					})
				}

			},
			getBeanList(){
				const that = this;
				var params = new Params(that,{
					pay_type	:'office_pc',
					method:'virgift.office.bean.shop'
				});
				this.$axios.post(that.$store.state.urlData.url,Qs.stringify(params),{//that.$store.state.urlData.url
					headers: {
              'Content-Type':'application/x-www-form-urlencoded'
          }
				}).then(function (res) {
					if (res.data.errCode==0) {
						that.rangeData = res.data.data
					}else{
						that.showTips(res.data.errMsg,that);
					}
				})
			},
			showTips(tips,that){
				that.tips = tips;
				setTimeout(()=>{
					that.tips = '';
	      },3000);
			}
		},
		mounted(){
			this.getBeanList();
		}
	}
</script>
<style scoped>
	.tips{
		position: fixed;
		display: none;
		width: 100%;
		height:100%;
		top: 0;
		left: 0;
		z-index: 99;
		opacity: 0;
		transition: all .5s;
	}

	.tips.on{
		display: block;
		opacity: 1;
	}

	.tips p{
		min-width: 100px;
		max-width: 300px;
		width: auto;
		padding: 15px 20px;
		display: inline-block;
		background: rgba(0, 0, 0,.8 );
		color: #FFFFFF;
		border-radius: 5px;
		margin: 20% auto;
	}
	.gw2{
		width: 870px;
		min-width: 870px;
		margin: 0 auto;
		display: inherit;
		margin-top: 120px;
		margin-bottom: 40px;
	}
	.mb30{
		margin-bottom: 30px;
	}

	.rc-block{
		width: 100%;
		display: inline-block;
		position: relative;
	}

	.rc-block .check-name,.rc-block .uname{
		position: absolute;
		text-decoration: none;
		color: #FF8700;
		right: 310px;
		top: 45px;
		font-size: 14px;
	}

	.rc-block .check-name{
		right: 220px;
	}

	.tit{
		font-size: 14px;
		color: #232323;
		letter-spacing: 0;
		text-align: left;
		margin-bottom: 15px;
		font-weight: bold;
	}
	input,.range p{
		border: 1px solid #E3E3E3;
		border-radius: 4px;
	}
	.borderView{
		border: 1px solid #E3E3E3;
		border-radius: 4px;
		float: left;
		/* width: 280px;
		height: 50px; */
		width: 280px;
		height: 80px;
		margin-right: 10px;
		text-align: center;
		line-height: 50px;
		cursor: pointer;
		margin-top: 15px;
		color: #FF8700;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
	.borderView.on{
		border: 1px solid #FF8700;
	}
	.borderView:nth-child(3n){
		margin-right: 0;
	}
	input[name='idtext']{
		width: 570px;
		height: 40px;
		display: block;
		text-indent: 1em;
		font-size: 14px;
		color: #232323;
		letter-spacing: 0;
		text-align: left;
	}
	.range{
		text-align: left;
	}
	
	.packBottom{
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		margin-top: -0.9rem;
	}
	.forView{
		/* background-color: blanchedalmond; */
		height: 20px;
		display: flex;
		align-items: center;
	}
	.toushiI{
		display: block;
		width: 15px;
		height: 15px;
		margin-left: 15px;
	}
	.toushiT{
		margin-left: 5px;
		font-size: 10px;
		color: #999999;
	}
	.range p{
		float: left;
		width: 280px;
		height: 50px;
		margin-right: 10px;
		text-align: center;
		line-height: 50px;
		cursor: pointer;
		margin-top: 15px;
	}
	.range p:nth-child(3n){
		margin-right: 0;
	}
	.range-span,.amount-span{
		display: inline-block;
		background: url("../assets/icon-bean.png") no-repeat  0 18px;
		background-size: 18px 13px;
		padding-left: 30px;
		font-size: 14px;
		color: #232323;
	}

	.range-span{
		/* margin-left: 20%; */
		margin-left: 5%;
		text-align: left;
		/* height: 30px; */
	}
	.amount-span{
		background: url("../assets/icon-bean.png") no-repeat 5px 3px;
		background-size: 18px 13px;
	}
	.range p.on{
		border: 1px solid #FF8700;
	}
	.range p.on .range-span{
		color: #FF8700;
	}
	.amount{
		width: 100%;
		box-sizing: border-box;
		padding: 30px 30px;
		background: #F7F7F9;
		border-radius: 6px;
		text-align: left;
		font-size: 14px;
	}
	.price{
		font-size: 20px;
		color: #FF8700;
		margin-top: 10px;
	}
	.payType{
		text-align: left;
	}
	.payType button{
		background: #ffffff;
		border: 1px solid #F54E31;
		width: 230px;
		height: 50px;
		border-radius: 4px;
		font-size: 20px;
		color: #F54E31;
		outline: none;
		cursor: pointer;
	}
	.payType button:last-child{
		color: #3AA5F2;
		border-color: #3AA5F2;
		/*margin-left: 20px;*/
	}
	.payType button span{
		display: inline-block;
		padding-left: 34px;
	}
	.payType button:first-child span{
		background: url("../assets/pay-sm.png") no-repeat 0 1px;
		background-size: 24px ;
	}
	.payType button:last-child span{
		background: url("../assets/pay-zfb.png") no-repeat 0 1px;
		background-size: 24px ;
	}
	.instructions p{
		color: #888888;
		text-align: left;
		font-size: 12px;
		line-height: 24px;
	}
	.instructions p span{
		color: #3AA5F2;
	}
	.ewm-block{
		margin-top: 15px;
		width: 230px;
		height: 260px;
		box-sizing: border-box;
		padding: 15px;
		border: 1px solid #E3E3E3;
		border-radius:6px;
		box-shadow: 2px 2px 2px 2px #E3E3E3;
		font-size: 14px;
	}
	.ewm-block img{
		width: 200px;
		height: 200px;
	}
	.ewm-block p{
		margin-top: 5px;
	}
	.radio-p{
		text-align: left;
		margin-top: 10px;
		font-size: 14px;
		background:url("../assets/icon_recharge.png") no-repeat 0 4px;
		background-size: 20px;
		line-height: 30px;
		text-indent: 2em;
		cursor: pointer;
		width: auto;
		width: 270px;
	}
	.radio-p.checked{
		background:url("../assets/icon_recharge1.png") no-repeat 0 4px;
		background-size: 20px;
	}

	.radio-p span{
		color: #F54E31;
	}

	.pay-box{
		height: 0;
		overflow: hidden;
		transition: all .3s;
	}

	.pay-box.show{
		height:320px;
	}
</style>



// WEBPACK FOOTER //
// src/page/recharge.vue